import axios from "axios";

export const fetchFirstAvailable = (data) => {
  return axios.get(`${process.env.REACT_APP_FLEXAPP}/os/firstavailable?c=${data.client}&providerId=${data.providerId}&appointmentId=${data.appointmentId}`);
}
